import { SIZE_PACKS } from "../constants/action-types";
import { IExportState, IUploadState } from "../reducers/size-packs-reducers";

export const uploadSizePacks = (result) => {
    const body = new FormData();
    body.append("fileData", JSON.stringify(result));

    return {
        type: SIZE_PACKS.UPLOAD.START,
        payload: { url: "/api/v3.0/vetl/size-packs/upload", body },
    };
};

export const startSizePacksUploadJobPolling = (payload) => ({ type: SIZE_PACKS.JOB.POLL.START, payload });

export const fetchSizePacksUploadJob = (jobId: string, pipelineId: string) => ({
    type: SIZE_PACKS.JOB.FETCH.START,
    payload: { url: "/api/v3.0/vetl/job", body: { jobId, pipelineId } },
});

export const exportSizePacks = (sizePacksStatus: string, fileFormat: string) => ({
    type: SIZE_PACKS.EXPORT.DOWNLOAD.START,
    payload: { url: "/api/v3.0/vetl/size-packs/export", body: { sizePacksStatus, fileFormat } },
});

export const fetchExportFileLink = (jobId: string, pipelineId: string) => ({
    type: SIZE_PACKS.EXPORT_FILE.FETCH.START,
    payload: { url: "/api/v3.0/vetl/size-packs/export-file", body: { jobId, pipelineId } },
});

export const updateImport = (payload: Partial<IUploadState>) => ({ type: SIZE_PACKS.UPDATE_IMPORT, payload });

export const updateExport = (payload: Partial<IExportState>) => ({ type: SIZE_PACKS.UPDATE_EXPORT, payload });
